import React from 'react';
import {
  SectionContent, 
  TextContent,
  LoadingMessage,
  ErrorMessage,
  SectionItemHeader,
} from './styles/PostSaleSection.styles';
import ProgressTracker from '../ProgressTracker';
import {
  getProgressData,
  getErrorMessage,
  getLoadingMessage,
} from '../utilities';

type PostSaleSectionItemProps = {
  sectionType: string;
  sectionData: any;
  sectionContent: any;
  sidebarContent: any;
  footerContent?: any;
  isLoading: boolean;
  hasError: boolean;
  statusCode?: string;
  showProgress: boolean;
  sectionItemHeader?: string | null;
  isDirectlyAboveFooter?: boolean;
  showEstimated: boolean;
};

const PostSaleSectionItem = ({
  sectionType,
  sectionData,
  sectionContent,
  sidebarContent = null,
  isLoading,
  hasError,
  statusCode = '',
  showProgress = true,
  sectionItemHeader = null,
  isDirectlyAboveFooter = false,
  showEstimated,
}: PostSaleSectionItemProps) => {
  const {
    daysLeft,
    totalDays,
    endDate,
    completed,
    maxMilage
  } = getProgressData(sectionData, sectionType);
  const loadingMessage = isLoading && getLoadingMessage(sectionType);
  const errorMessage = hasError && getErrorMessage(sectionType, statusCode);
  if (!isDirectlyAboveFooter) isDirectlyAboveFooter = false;

  return (
    <SectionContent completed={completed} hasProgressBar={showProgress} isDirectlyAboveFooter={isDirectlyAboveFooter}>
      { showProgress && (
        <ProgressTracker
          sectionType={sectionType}
          daysLeft={daysLeft}
          totalDays={totalDays}
          endDate={endDate}
          completed={completed}
          maxMilage={maxMilage}
          showEstimated={showEstimated}
          isLoading={isLoading}
        />
      )}
      { (!showProgress && sidebarContent !== null) && 
        sidebarContent
      }
      <TextContent showProgress={showProgress || sidebarContent !== null}>
        {sectionItemHeader &&
          <SectionItemHeader>{sectionItemHeader}</SectionItemHeader>}
        {isLoading &&
          <LoadingMessage>{loadingMessage}</LoadingMessage>
        }
        {hasError &&
          <ErrorMessage>{errorMessage}</ErrorMessage>
        }
        {!isLoading && !hasError &&
          sectionContent
        }
      </TextContent>
    </SectionContent>
  );
};

export default PostSaleSectionItem;
